<template>
  <tr>
    <td>
      <b-form-input
        v-model="objTest.iniciativasInversion"
        type="text"
      ></b-form-input>
    </td>



    <td>
      <b-form-input
        v-model="objTest.pptoFinalAnio"
        type="number"
      ></b-form-input>
    </td>
    <td>
      <b-form-input
        v-model="objTest.ejecucionAnio"
        type="number"
      ></b-form-input>
    </td>
    <td>$ {{ difference(objTest) }}</td>
    <td>
      <b-form-input v-model="objTest.notas" type="text"></b-form-input>
    </td>
    <td><i @click="removeItem(objTest)" class="bx bxs-trash"></i></td>
  </tr>
</template>
<script>
export default {
  props: ["removeItem", "objTest", "anio", "itemList", "difference", "perc"],
  data() {
    return {
      totalPorcetain: "",
      totaResta: "",
      porcetain: "",
    };
  },
  watch: {
    itemList: async function() {
      console.log(this.itemList) 
    },
  },
};
</script>

<style scoped>
.controller-forms {
  font-size: 0.8rem !important;
  width: 100% !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.bxs-trash {
  font-size: 1.5rem;
  color: #25a2b7;
  cursor: pointer;
}
</style>
